export default "__VITE_ASSET__DMFbWvR___"